const NotFound= () => {
    return (<div>Not found page</div>)
}

export default NotFound